import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {ActivatedRoute, Router} from '@angular/router';
import {InviteV2} from 'src/app/models/invite-v2';
import {CryptoService} from 'src/app/services/crypto.service';
import {EmailService} from 'src/app/services/email.service';
import {InviteSpeakersService} from 'src/app/services/invite-speakers.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-speaker-confirm-back',
  templateUrl: './speaker-confirm-back.component.html',
  styleUrls: [ './speaker-confirm-back.component.scss' ]
})
export class SpeakerConfirmBackComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public member_id: any;
  public letter_id: any;
  public event_id: any;

  public invite: InviteV2;
  public welcome: any
  public entityForm: FormGroup;

  // public fired: boolean = false;
  public member: any = {}
  public publishSlides: any = null;

  constructor (
    private _activeRoute: ActivatedRoute,
    public _inviteSpeakersService: InviteSpeakersService,
    private fb: FormBuilder,
    private _router: Router,
    private _cryptoService: CryptoService,
    private _emailService: EmailService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit () {
    this._activeRoute.params.subscribe(data => {
      const param = data[ 'uid' ];
      const params = param.split(":")
      this.member_id = params[ 0 ]
      this.letter_id = params[ 1 ]
      this.event_id = params[ 2 ]
    })

    this.entityForm = this.createForm()
    this.getInvite()
  }

  getInvite () {
    // selecionar o convite adequado para registrar a resposta
    this._inviteSpeakersService.selectByInvite(this.member_id, this.letter_id, this.event_id)
      .subscribe((result) => {

        result.forEach(element => {
          this.invite = new InviteV2();
          this.invite.id = element.id;
          this.invite.event_name = element.data().event_name
          this.invite.member_id = element.data().member_id
          this.invite.member_name = element.data().member_name
          this.invite.letter_id = element.data().letter_id
          this.invite.letter_name = element.data().letter_name
          this.invite.member_email = this._cryptoService.get(this._cryptoService.key, element.data().member_email)
          this.invite.agenda = element.data().agenda

          if (!element.data().date_response) {
            this.invite.agenda.forEach((ag) => {
              console.log(ag.acceptInvite)
              ag.acceptInvite = null
            })
          }

          this.invite.accept = element.data().accept ? element.data().accept : false;
          this.invite.date_sent = element.data().date_sent ? element.data().date_sent : null;
          this.invite.date_response = element.data().date_response ? element.data().date_response : null;
        });

        // console.log(JSON.stringify(this.invite.agenda))

      })
  }

  updateAccept (obs: string) {
    let allMark: boolean = true;

    for (let i = 0; i < this.invite.agenda.length; i++) {
      if (this.invite.agenda[ i ].acceptInvite == null) {
        console.log('acceptInvite null')
        allMark = false
        break;
      }
    }

    if (!allMark) {
      this.dialog.open(AlertComponent, {
        width: '350px',
        height: '270px',
        panelClass: 'custom-dialog-container',
        data: {title: "Alerta!", message: "<br>Todos os ítens do convite <br>devem ser marcados como<br><i>Aceito</i>, ou <i>Não aceito</i>!"}
      });
    }
    else {

      if (this.publishSlides == null) {
        this.dialog.open(AlertComponent, {
          width: '350px',
          height: '270px',
          panelClass: 'custom-dialog-container',
          data: {title: "Alerta!", message: "<br>A autorização para publicação <br>dos materiais utilizados nas<br>apresentações deve ser marcada<br>como <i>Autorizo</i>, ou <i>Não autorizo</i>."}
        });
      } else {
        this.processAccept(obs)
      }

    }

  }

  processAccept (obs: string) {
    const agenda: any = this.invite.agenda

    let acceptAll: boolean = false
    let countRejection: number = 0;

    agenda.forEach(item => {
      if (!item.acceptInvite) {
        countRejection++
      }
    });

    if (countRejection == 0) {
      acceptAll = true
    } else {
      acceptAll = false
    }

    const updatedData: any = {
      'accept': acceptAll,
      'date_response': new Date(),
      'admin_response': false,
      'agenda': agenda,
      'obs': obs,
      'publishSlides': this.publishSlides
    }

    console.log(JSON.stringify(updatedData))

    this._inviteSpeakersService.registerResponse(this.invite.id, updatedData)
      .then(() => {
        this._router.navigate([ 'speaker-update-back/' + this.member_id + ':' + this.letter_id + ':' + this.event_id + ':' + true ]);
        this.sendFeedBackEmail(this.invite, updatedData)
      })
      .catch((err) => {
        console.log("erro")
      })

  }

  sendFeedBackEmail (invite: any, data: any) {
    let emailFeedBack = this.makeEmailFeedBack(invite, data)

    const emailFeedback: any = {
      'html': emailFeedBack,
      'subject': 'Resposta Carta Convite',
      'to': 'cientifico@sbccv.org.br',
      'from': 'sbccv.cientifico@gmail.com',
      'bcc': 'meryt@sbccv.org.br, elenilda@sbccv.org.br'
      // 'bcc': 'carlos@otero.net.br' 
       }

    this._emailService.sendStandardEmail(emailFeedback)
  }

  makeEmailFeedBack (invite: any, data: any) {

    let resumo_atividade: string = "";

    resumo_atividade += "<div>";
    resumo_atividade += "Resposta Carta Convite";
    resumo_atividade += "</div>";

    resumo_atividade += "<hr>";

    resumo_atividade += "<div>";
    resumo_atividade += invite.event_name;
    resumo_atividade += "</div>";

    resumo_atividade += "<div>";
    resumo_atividade += invite.letter_name;
    resumo_atividade += "</div>";

    resumo_atividade += "<div>";
    resumo_atividade += invite.member_name;
    resumo_atividade += "</div>";

    resumo_atividade += "<hr>";

    data.agenda.forEach(appointment => {

      resumo_atividade += "<ul>";

      resumo_atividade += "<div>";
      resumo_atividade += "<span>" + appointment.role_name + "</span>";
      if (appointment.level == 't') {
        resumo_atividade += "<span> no tópico</span>";
        if (appointment.acceptInvite) {
          resumo_atividade += "<span> - <b>ACEITO</b></span>";
        } else {
          resumo_atividade += "<span> - <b>RECUSADO</b></span>";
        }

      } else if (appointment.level == 'a') {
        resumo_atividade += "<span> na atividade</span>";
        if (appointment.acceptInvite) {
          resumo_atividade += "<span> - <b>ACEITO</b></span>";
        } else {
          resumo_atividade += "<span> - <b>RECUSADO</b></span>";
        }
      }
      resumo_atividade += "</div>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Data: </div>";
      resumo_atividade += "<div>" + appointment.day_date_string + "</div>";
      resumo_atividade += "</li>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Atividade: </div>";
      resumo_atividade += "<div>" + appointment.activity_startTime + " - " + appointment.activity_name + "</div>";
      resumo_atividade += "</li>";

      if (appointment.level == 't') {

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Tópico: </div>";
        resumo_atividade += "<div>" + appointment.topic_startTime + " - " + appointment.topic_name + "</div>";
        resumo_atividade += "<div>" + appointment.topic_duration + " minutos" + "</div>";
        resumo_atividade += "</li>";

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Equipe do Tópico</div>"

        appointment.topicStaff.forEach(st => {
          resumo_atividade += "<div style='margin-left:20px;'>";
          resumo_atividade += st.role_name + " - " + st.member_name;
          resumo_atividade += "</div>";
        });
        resumo_atividade += "</li>";

        resumo_atividade += "<hr>";
      }

      if (appointment.level == 'a') {
        resumo_atividade += "<ul>";
        resumo_atividade += "<div>Equipe da atividade</div>";

        appointment.activityStaff.forEach(st => {
          resumo_atividade += "<li>";
          resumo_atividade += st.role_name + " - " + st.member_name;
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";

        resumo_atividade += "<hr>";

        resumo_atividade += "<ul>"
        appointment.activityTopics.forEach(ac => {
          resumo_atividade += "<li>";
          resumo_atividade += ac.topic_startTime + " - " + ac.topic_name;
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";
      }

      resumo_atividade += "</ul>";
    });

    resumo_atividade += '<div>'
    resumo_atividade += '<div>OBSERVAÇÃO:</div>'
    resumo_atividade += '<div>' + data.obs + '</div>'
    resumo_atividade += '</div>'

    return resumo_atividade

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      obs: new FormControl(''),
    });
    return form
  }

  onRadioChange (event) {
    console.log(event)
  }
}
